export default __webpack_public_path__ + "static/media/fullscreen-pink-16px.7b2c0be5.svg";